import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';

import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../assets/scss/main.scss';

import HeaderPart from '../shared/parts/HeaderPart';
import FooterPart from '../shared/parts/FooterPart';
import PageNotFound from './PageNotFound';

const app = ReactDOM.createRoot(document.getElementById('root'));
app.render(
	<RecoilRoot>
		<HeaderPart />
		<PageNotFound />
		<FooterPart />
	</RecoilRoot>
);

